import axios from "axios";

// Endpoint publico: la autorizacion es el token firmado que viaja en el cuerpo
// de la peticion, y lo valida el backend. No poner credenciales en este
// fichero: acaba entero en el bundle que se sirve al navegador.
const UseFetch = async (method, url, abortController = new AbortController(), params) => {
  const signal = abortController.signal;

  return await axios[method.toLowerCase()](url, ...(method.toLowerCase() === "get" ? [{ signal }] : [params, { signal }]));
};

export default UseFetch;
